<template>
  <div :class="['sidenav', { collapsed: isCollapsed }]">
    <br />
    <div class="links">
      <ul class="">
        <div class="row">
          <div v-if="!isCollapsed" class="col-lg-10">
            <img
              src="../assets/images/logo.png"
              class="col-12"
              alt=""
              srcset=""
            />
          </div>
          <div v-else class="col-lg-12">
            <!-- Collapsed: the K mark IS the expand toggle. It crossfades into
                 the » chevrons on hover/focus, then clicking reopens the rail. -->
            <button
              type="button"
              class="sidenav-logo-toggle"
              @click="toggleSidenav"
              aria-label="Expand sidebar"
              title="Expand"
            >
              <img
                src="../assets/images/logo-icon.png"
                class="sidenav-logo-icon sidenav-logo-toggle__logo"
                alt=""
                srcset=""
                aria-hidden="true"
              />
              <!-- Crisp vector chevrons (»): stay sharp at any scale, unlike the
                   raster collapse PNG which blurs when the spring animation
                   overshoots past 100%. -->
              <svg
                class="sidenav-logo-toggle__expand"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.4"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <polyline points="6 5 13 12 6 19" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </button>
          </div>
          <button v-if="!isCollapsed" class="toggle-btn" @click="toggleSidenav">
            <img src="../assets/images/icons/sidenav-collapse.png" />
          </button>
        </div>
        <hr />
        <router-link
          :to="{ name: DASHBOARD_ROUTE }"
        >
          <li
            :class="[route == DASHBOARD_ROUTE ? 'selected' : null, 'nav-items']"
          >
            <span class="router-link">
              <img
                src="../assets/images/icons/sidenav/dashboard.svg"
                class="sidenav-icon"
                alt=""
                aria-hidden="true"
              />
              <span class="d-none d-lg-block">Dashboard</span>
            </span>
          </li>
        </router-link>
        <router-link
          :to="{ name: ANNOUNCEMENTS_N_ROUTE }"
        >
          <li
            :class="[[ANNOUNCEMENTS_N_ROUTE, ANNOUNCEMENTS_ROUTE, ADD_ANNOUNCEMENT_ROUTE, EDIT_ANNOUNCEMENT_ROUTE, DUPLICATE_ANNOUNCEMENT_ROUTE].includes(route) ? 'selected' : null, 'nav-items']"
          >
            <span class="router-link">
              <img
                src="../assets/images/icons/sidenav/Announcement.svg"
                class="sidenav-icon"
                alt=""
                aria-hidden="true"
              />
              <span class="d-none d-lg-block">Announcements</span>
            </span>
          </li>
        </router-link>
        <router-link
          :to="{ name: SHIUREI_TORAH_N_ROUTE }"
        >
          <li
            :class="[[SHIUREI_TORAH_N_ROUTE, ADD_SHIUREI_TORAH_ROUTE, EDIT_SHIUREI_TORAH_ROUTE, DUPLICATE_SHIUREI_TORAH_ROUTE].includes(route) ? 'selected' : null, 'nav-items']"
          >
            <span class="router-link">
              <img
                src="../assets/images/icons/sidenav/Shiurei_Torah.svg"
                class="sidenav-icon"
                alt=""
                aria-hidden="true"
              />
              <span class="d-none d-lg-block">Shiurei Torah</span>
            </span>
          </li>
        </router-link>
        <router-link
          :to="{ name: POSTERS_ROUTE }"
        >
          <li
            :class="[route == POSTERS_ROUTE ? 'selected' : null, 'nav-items']"
          >
            <span class="router-link">
              <img
                src="../assets/images/icons/sidenav/Posters.svg"
                class="sidenav-icon"
                alt=""
                aria-hidden="true"
              />
              <span class="d-none d-lg-block">Posters</span>
            </span>
          </li>
        </router-link>
        <router-link
          :to="{ name: DONATIONS_N_ROUTE }"
        >
          <li
            :class="[[DONATIONS_N_ROUTE].includes(route) ? 'selected' : null, 'nav-items']"
          >
            <span class="router-link">
              <img
                src="../assets/images/icons/sidenav/Donation.svg"
                class="sidenav-icon"
                alt=""
                aria-hidden="true"
              />
              <span class="d-none d-lg-block">Donations</span>
            </span>
          </li>
        </router-link>
        <router-link
          :to="{ name: MINYANIM_ROLLS_N_ROUTE }"
        >
          <li
            :class="[[MINYANIM_ROLLS_N_ROUTE, ADD_MINYANIM_ROLL_N_ROUTE, EDIT_MINYANIM_ROLL_N_ROUTE].includes(route) ? 'selected' : null, 'nav-items']"
          >
            <span class="router-link">
              <img
                src="../assets/images/icons/sidenav/Minyunim.svg"
                class="sidenav-icon sidenav-icon--minyunim"
                alt=""
                aria-hidden="true"
              />
              <!-- Badge sits inside the label: the label is the flex item that
                   absorbs the row's slack, so a sibling badge gets pushed to
                   the far edge. -->
              <span class="d-none d-lg-block">
                Minyanim
                <!-- <span class="new-feature-badge">New Update</span> -->
              </span>
            </span>
          </li>
        </router-link>
        <router-link :to="{ name: ZMANIM_N_ROUTE }">
          <li
            :class="[[ZMANIM_N_ROUTE, ADD_ZMANIM_N_ROUTE, EDIT_ZMANIM_N_ROUTE].includes(route) ? 'selected' : null, 'nav-items']"
          >
            <span class="router-link">
              <img
                src="../assets/images/icons/sidenav/Zmanim.svg"
                class="sidenav-icon"
                alt=""
                aria-hidden="true"
              />
              <span class="d-none d-lg-block">Zmanim
                <!-- <span class="new-feature-badge">New Update</span> -->
              </span>
            </span>
          </li>
        </router-link>
        <router-link
          :to="{ name: DATE_TIME_BANNER_ROUTE }"
        >
          <li
            :class="[route == DATE_TIME_BANNER_ROUTE ? 'selected' : null, 'nav-items']"
          >
            <span class="router-link">
              <img
                src="../assets/images/icons/sidenav/Calendar.svg"
                class="sidenav-icon"
                alt=""
                aria-hidden="true"
              />
              <span class="d-none d-lg-block">Date Time Banner</span>
            </span>
          </li>
        </router-link>
        <!-- KTYT — the Kabbalah feature. The label is the shul's own shorthand
             for it; the route and every file behind it are named Kabbalah.
             It sits last because it is the only row carrying an outside brand.
             The mark is inlined rather than linked as an <img> for the same
             reason the pill is tokenised below: only an inline glyph can
             follow `currentColor` into the row's active state. -->
        <!-- <router-link :to="{ name: KABBALAH_N_ROUTE }">
          <li
            :class="[route == KABBALAH_N_ROUTE ? 'selected' : null, 'nav-items', 'ktyt-nav']"
          >
            <span class="router-link">
              <svg
                class="sidenav-icon"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M2.25 13.5a0.75 0.75 0 0 1 -0.75 -0.75V3a0.75 0.75 0 0 1 0.75 -0.75H6a3 3 0 0 1 3 3a3 3 0 0 1 3 -3h3.75a0.75 0.75 0 0 1 0.75 0.75v9.75a0.75 0.75 0 0 1 -0.75 0.75h-4.5a2.25 2.25 0 0 0 -2.25 2.25a2.25 2.25 0 0 0 -2.25 -2.25z"
                  stroke="currentColor" stroke-width="1.07666" stroke-linecap="round" stroke-linejoin="round"
                />
                <path
                  d="M9 5.25v10.5"
                  stroke="currentColor" stroke-width="1.07666" stroke-linecap="round" stroke-linejoin="round"
                />
              </svg>
              <span class="d-none d-lg-block">KTYT</span>
            </span>
          </li>
        </router-link> -->
      </ul>
    </div>
    <div class="sidenav-footer">
      <ul class="sidenav-bottom-nav">
        <router-link
          :to="{ name: API_KEYS_ROUTE }"
        >
          <li
            :class="[route == API_KEYS_ROUTE ? 'selected' : null, 'nav-items']"
          >
            <span class="router-link">
              <img
                src="../assets/images/icons/sidenav/API.svg"
                class="sidenav-icon"
                alt=""
                aria-hidden="true"
              />
              <span class="d-none d-lg-block">API Keys</span>
            </span>
          </li>
        </router-link>
        <!-- Support tickets. The count beside the label is the tickets with
             unread replies; once the rail is retracted and the label has
             folded away, a dot on the icon says the same. -->
        <router-link :to="{ name: TICKETS_ROUTE }">
          <li
            :class="[route == TICKETS_ROUTE ? 'selected' : null, 'nav-items']"
          >
            <span class="router-link">
              <img
                src="../assets/images/icons/sidenav/Tickets.svg"
                class="sidenav-icon"
                alt=""
                aria-hidden="true"
              />
              <span v-if="unreadTickets" class="sidenav-icon-dot" :title="unreadTicketsTitle"></span>
              <span class="d-none d-lg-block">
                Tickets
                <span v-if="unreadTickets" class="tk-badge sidenav-badge" :title="unreadTicketsTitle">{{ unreadTicketsLabel }}</span>
              </span>
            </span>
          </li>
        </router-link>
        <router-link :to="{ name: SETTINGS_ROUTE }">
          <li
            :class="[route == SETTINGS_ROUTE ? 'selected' : null, 'nav-items']"
          >
            <span class="router-link">
              <img
                src="../assets/images/icons/sidenav/settings.svg"
                class="sidenav-icon"
                alt=""
                aria-hidden="true"
              />
              <span class="d-none d-lg-block">Settings</span>
            </span>
          </li>
        </router-link>
        <li class="nav-items signout-nav-item">
          <button type="button" class="router-link signout-nav-link" @click="logout">
            <img
              src="../assets/images/icons/sidenav/Logout.svg"
              class="sidenav-icon"
              alt=""
              aria-hidden="true"
            />
            <span class="d-none d-lg-block signout-nav-text">Signout</span>
          </button>
        </li>
      </ul>
      <!-- <div class="card profile-card">
        <div class="card-body">
          <div class="card-header">
            
          </div>
          <div class="logo" :style="{ width: isCollapsed ? '60%' : '25%', marginLeft: isCollapsed ? '20%' : '37.5%' } ">
            <img src="../assets/images/logo-icon.png" alt="">
          </div>
          <div class="content">
            <h6 v-if="!isCollapsed" class="email text-center">{{ account.email }}</h6>
            <button v-on:click="logout()" class="btn btn-custom-primary col-12">
              <span v-if="!isCollapsed">Logout</span>
              <font-awesome-icon v-else
                icon="fa-solid fa-arrow-right-from-bracket"
                class="fa"
                style="font-size: 0.8rem; position: relative; right: 3px"
              />
            </button>
            <small v-if="!isCollapsed" class="text-center">SK.2.1.3</small>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import {
  DASHBOARD_ROUTE,
  ANNOUNCEMENTS_ROUTE,
  ADD_ANNOUNCEMENT_ROUTE,
  EDIT_ANNOUNCEMENT_ROUTE,
  DUPLICATE_ANNOUNCEMENT_ROUTE,
  ADD_SHIUREI_TORAH_ROUTE,
  EDIT_SHIUREI_TORAH_ROUTE,
  DUPLICATE_SHIUREI_TORAH_ROUTE,
  DONATIONS_ROUTE,
  MEMBERS_ROUTE,
  MINYUNIM_ROUTE,
  MINYANIM_COUNTDOWN_ROUTE,
  ZMANIM_ROUTE,
  EMAIL_ROUTE,
  TEXTS_ROUTE,
  ADD_DONATION_ROUTE,
  DATE_TIME_BANNER_ROUTE,
  POSTERS_ROUTE,
  API_KEYS_ROUTE,
  SETTINGS_ROUTE,
  MINYANIM_ROLLS_N_ROUTE,
  ADD_MINYANIM_ROLL_N_ROUTE,
  EDIT_MINYANIM_ROLL_N_ROUTE,
  ZMANIM_N_ROUTE,
  KABBALAH_N_ROUTE,
  ADD_ZMANIM_N_ROUTE,
  EDIT_ZMANIM_N_ROUTE,
  DONATIONS_N_ROUTE,
  ANNOUNCEMENTS_N_ROUTE,
  SHIUREI_TORAH_N_ROUTE,
  TICKETS_ROUTE
} from '@/router/routes';
import { CLEAR_ERRORMSG, LOGOUT, UPDATE_SIDENAV } from '@/store/action_types';
import {
  ADMIN_ROLES,
  DEFAULT_ERROR_MSG,
  TOAST_GLOBAL_CONFIG,
  USER_ROLES,
} from '@/utils/const';
import { library } from '@fortawesome/fontawesome-svg-core'; 
import {
  faArrowRightFromBracket,
  faWrench,
  faGear
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faArrowRightFromBracket,
  faWrench,
  faGear
);

export default {
  data() {
    return {
      DASHBOARD_ROUTE,
      MEMBERS_ROUTE,
      ANNOUNCEMENTS_ROUTE,
      ADD_ANNOUNCEMENT_ROUTE,
      EDIT_ANNOUNCEMENT_ROUTE,
      DUPLICATE_ANNOUNCEMENT_ROUTE,
      ADD_SHIUREI_TORAH_ROUTE,
      EDIT_SHIUREI_TORAH_ROUTE,
      DUPLICATE_SHIUREI_TORAH_ROUTE,
      DONATIONS_ROUTE,
      ADD_DONATION_ROUTE,
      MINYUNIM_ROUTE,
      MINYANIM_COUNTDOWN_ROUTE,
      ZMANIM_ROUTE,
      EMAIL_ROUTE,
      TEXTS_ROUTE,
      DATE_TIME_BANNER_ROUTE,
      API_KEYS_ROUTE,
      SETTINGS_ROUTE,
      MINYANIM_ROLLS_N_ROUTE,
      POSTERS_ROUTE,
      ADD_MINYANIM_ROLL_N_ROUTE,
      EDIT_MINYANIM_ROLL_N_ROUTE,
      ZMANIM_N_ROUTE,
      KABBALAH_N_ROUTE,
      ADD_ZMANIM_N_ROUTE,
      EDIT_ZMANIM_N_ROUTE,
      DONATIONS_N_ROUTE,
      ANNOUNCEMENTS_N_ROUTE,
      SHIUREI_TORAH_N_ROUTE,
      TICKETS_ROUTE,
      // isCollapsed: true
    };
  },
  computed: {
    route() {
      return this.$route.name;
    },
    errorMessage() {
      return this.$store.getters.errorMsg;
    },
    isCollapsed() {
      return this.$store.getters.isCollapsed;
    },
    account() {
      return this.$store.getters.account.data;
    },
    // Tickets with unread replies — the badge on the Tickets row
    // (utils/ticket_notifications keeps it current).
    unreadTickets() {
      return Number(this.$store.getters.ticketUnread?.data?.tickets) || 0;
    },
    unreadTicketsLabel() {
      return this.unreadTickets > 99 ? '99+' : String(this.unreadTickets);
    },
    unreadTicketsTitle() {
      const count = this.unreadTickets;
      return `${count} ${count === 1 ? 'ticket' : 'tickets'} with unread replies`;
    },
  },
  watch: {
    errorMessage: {
      handler(val) {
        if (val != null) {
          this.$toast.error(val ?? DEFAULT_ERROR_MSG, TOAST_GLOBAL_CONFIG);
          this.$store.dispatch(CLEAR_ERRORMSG);
        }
      },
    },
  },
  methods: {
    toggleSidenav() {
      // this.isCollapsed = !this.isCollapsed;
      // this.$emit('collapsed', this.isCollapsed)

      this.$store.dispatch(UPDATE_SIDENAV, !this.isCollapsed)
    },
    logout() {
      this.$store.dispatch(LOGOUT, { recordSignOut: true }).then((res) => {
        this.$router.go();
      });
    },
  },
};
</script>
<style scoped>
/* =========================================================================
   Rail geometry — the icon column is the anchor.

   Every horizontal offset below is a fixed px length shared by BOTH states, so
   the icons sit at exactly the same x whether the rail is open or shut.
   Retracting only narrows the rail and collapses the labels out from behind
   the icons; the icons themselves never move, resize or re-centre. (Same
   behaviour as Gemini's sidebar.)

   Two consequences worth spelling out, because they are what usually breaks
   this: nothing here may be a percentage (a % offset moves with the rail
   width), and the icon may not change size between states (resizing a
   left-aligned box moves its centre).

   The component is dropped into a bootstrap `.row`, which pulls its children
   15px left of the visible area. `--sk-rail-lead` is padding that exists
   purely to cancel that out, so the sidenav's *visible* left edge is the start
   of its content box — in both states, at every breakpoint.

     |<-- lead -->|<- mx ->|<- pad ->[ icon ]<- gap ->[ label … ]
     ^ border box  ^ pill    ^ 20px slot
                  ^ visible edge (x = 0)

   `--sk-item-pad` is derived rather than typed in: it is whatever centres the
   icon slot inside the collapsed pill, which is also what centres it in the
   collapsed rail. Change the rail width or the gutter and the column stays
   centred on its own.
   ========================================================================= */
.sidenav {
  --sk-rail-lead: 15px;      /* cancels the bootstrap .row negative margin */
  /* Border-box width of the retracted rail. Owned by theme.css because every
     page's `.collapsed-col` subtracts the same token to claim the rest of the
     row — the two must stay in lockstep or the retracted state leaves dead
     space on the right. Never hardcode it here. */
  --sk-rail-collapsed: var(--sidenav-collapsed-width, 63px);
  /* Usable width once the lead padding and the 1px right border are removed. */
  --sk-rail-inner: calc(var(--sk-rail-collapsed) - var(--sk-rail-lead) - 1px);
  --sk-item-mx: 8px;         /* pill gutter, identical in both states */
  --sk-icon-slot: 20px;      /* layout box every icon occupies */
  --sk-icon-gap: 12px;       /* icon -> label; only exists while expanded */
  --sk-header-h: 50px;       /* brand row, pinned so the nav below cannot shift */
  --sk-item-pad: calc(
    (var(--sk-rail-inner) - 2 * var(--sk-item-mx) - var(--sk-icon-slot)) / 2
  );
  /* Left edge of the icon column, measured from the visible edge of the rail. */
  --sk-icon-left: calc(var(--sk-item-mx) + var(--sk-item-pad));

  display: flex;
  flex-direction: column;
  height: 100vh;
  padding-left: var(--sk-rail-lead);
  padding-right: 0px;
  padding-bottom: 3px;
  background-color: var(--color-bg-canvas) !important;
  border-right: 1px solid var(--color-border);
  /* Only the rail's width animates. Its padding is state-independent — that is
     precisely what keeps the icon column still. */
  transition: width 0.3s ease;
}

.sidenav.collapsed {
  width: var(--sk-rail-collapsed);
  /* Guards against the flex row squeezing the rail below its designed width. */
  min-width: var(--sk-rail-collapsed);
}

/* The mark is 37px natural, but .col-12 stretches it to the column width and
   upscales it. Pin it instead so it stays sharp and rail-width independent. */
.sidenav.collapsed .sidenav-logo-icon {
  width: 34px;
  height: auto;
  max-width: 100%;
  padding: 0;
  margin: 0 auto;
  display: block;
}

/* -------------------------------------------------------------------------
   Collapsed logo doubles as the expand toggle.
   The K mark and the » expand chevrons are stacked on the same centre; on
   hover/focus the mark shrinks + fades out while the chevrons spring + fade
   in, so the logo itself is the affordance to reopen the rail. Clicking it
   anywhere toggles the sidenav.
   ------------------------------------------------------------------------- */
.sidenav-logo-toggle {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  /* `auto` side margins put it on the icon column (the collapsed rail's inner
     box is symmetric around it); the brand row centres it vertically. */
  margin: 0 auto;
  padding: 0;
  border: none;
  border-radius: 10px;
  background: transparent;
  cursor: pointer;
  transition: background-color 0.25s ease;
}

.sidenav-logo-toggle:hover,
.sidenav-logo-toggle:focus-visible {
  background: var(--color-bg-muted, #f3f4f6);
}

.sidenav-logo-toggle:focus {
  outline: none;
}

.sidenav-logo-toggle:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

/* Both marks occupy the exact same spot so one crossfades into the other. */
.sidenav.collapsed .sidenav-logo-toggle__logo,
.sidenav-logo-toggle__expand {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 0;
  padding: 0;
  transition: opacity 0.28s ease, transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  will-change: opacity, transform;
}

/* K mark — shown at rest. */
.sidenav.collapsed .sidenav-logo-toggle__logo {
  width: 34px;
  height: auto;
  opacity: 1;
  transform: translate(-50%, -50%) scale(1) rotate(0deg);
}

/* » expand chevrons — crisp vector, so the spring overshoot never blurs it. */
.sidenav-logo-toggle__expand {
  width: 24px;
  height: 24px;
  color: var(--color-primary);
  opacity: 0;
  transform: translate(-50%, -50%) scale(0.4);
}

/* Hover / keyboard focus: mark out, chevrons in. */
.sidenav-logo-toggle:hover .sidenav-logo-toggle__logo,
.sidenav-logo-toggle:focus-visible .sidenav-logo-toggle__logo {
  opacity: 0;
  transform: translate(-50%, -50%) scale(0.5) rotate(-12deg);
}

.sidenav-logo-toggle:hover .sidenav-logo-toggle__expand,
.sidenav-logo-toggle:focus-visible .sidenav-logo-toggle__expand {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1);
}

/* Respect users who prefer less motion: keep the crossfade, drop the movement. */
@media (prefers-reduced-motion: reduce) {
  .sidenav.collapsed .sidenav-logo-toggle__logo,
  .sidenav-logo-toggle__expand {
    transition: opacity 0.18s linear;
  }
  .sidenav.collapsed .sidenav-logo-toggle__logo,
  .sidenav-logo-toggle__expand,
  .sidenav-logo-toggle:hover .sidenav-logo-toggle__logo,
  .sidenav-logo-toggle:focus-visible .sidenav-logo-toggle__logo,
  .sidenav-logo-toggle:hover .sidenav-logo-toggle__expand,
  .sidenav-logo-toggle:focus-visible .sidenav-logo-toggle__expand {
    transform: translate(-50%, -50%);
  }
}

/* Brand row is pinned to one height in both states and its contents centred in
   it. Left to itself the wordmark's height comes from the rail's width, so the
   open and shut headers were different heights — which pushed the divider and
   every icon below it up or down on collapse. Holding it still is the vertical
   half of "nothing moves". */
.sidenav .links ul > .row {
  align-items: center;
  min-height: var(--sk-header-h);
  /* The collapse toggle has to stay on the wordmark's line. Left to wrap it
     dropped onto a second row below ~1220px, which made the open header taller
     than the shut one and pushed the whole icon column down on collapse. */
  flex-wrap: nowrap;
}

/* Let the wordmark's column give up width to the toggle rather than wrap it.
   The logo is object-fit:contain, so it just scales down inside the same box. */
.sidenav .links ul > .row > .col-lg-10 {
  flex-shrink: 1;
  min-width: 0;
}

/* Wordmark starts on the icon column, so the brand and the nav read as one left
   edge. It is letterboxed into the fixed row height rather than sized by it, so
   it keeps its aspect and simply gets smaller on a narrower rail.
   (Bootstrap's .col-12 padding on the <img> is what sets its inset; the right
   side keeps the stock 15px so the logo keeps its current size.) */
.sidenav .links ul .row img.col-12 {
  height: var(--sk-header-h);
  padding-left: var(--sk-icon-left);
  object-fit: contain;
  object-position: left center;
}

.sidenav.collapsed .links ul .row {
  margin-left: 0;
  margin-right: 0;
}

.sidenav.collapsed .links ul .row > div {
  padding-left: 0;
  padding-right: 0;
}

.sidenav.collapsed .toggle-container {
  display: flex;
  justify-content: center; /* center horizontally */
  align-items: center; /* center vertically */
  height: 40px;
  font-size: 1.5rem!important;
  margin-top: 35px;
}

.sidenav .toggle-container {
  display: flex;
  justify-content: end; /* end horizontally */
  align-items: end; /* end vertically */
  height: 60px; /* Adjust height to match the design */
  position: relative;
  bottom: 15px;
}

.toggle-btn {
  background-color: transparent;
  border: none;
  color: var(--color-primary);
  font-size: 1.2rem;
  cursor: pointer;
  margin-right: 13px;
}

.toggle-btn:focus {
  outline: none;
}

.sidenav.collapsed .fa {
  font-size: 1.2rem; /* Adjust icon size */
}

/* Divider lines up with the nav pills, so in the retracted rail it reads as
   exactly as wide as the buttons under it. */
.sidenav hr {
  margin-left: var(--sk-item-mx);
  margin-right: var(--sk-item-mx);
  margin-bottom: 30px;
}

.sidenav ul {
  list-style: none;
  width: 100%;
  margin-block-start: 0px;
  padding-inline-start: 0px;
}

.sidenav ul a:hover {
  text-decoration: unset;
}

/* Pill box — state-independent by design. `.selected` below only repaints it;
   it must never restate geometry, or the two states could drift apart. */
.sidenav ul .nav-items,
.sidenav-bottom-nav .nav-items {
  width: calc(100% - 2 * var(--sk-item-mx));
  margin-left: var(--sk-item-mx);
  margin-right: var(--sk-item-mx);
  margin-top: 4px;
  padding: 0.55rem var(--sk-item-pad);
  font-weight: 500;
  font-size: 0.9rem;
  line-height: 1.5rem;
  color: var(--color-text-secondary);
  border-radius: var(--radius-md) !important;
  transition: background-color .15s ease, color .15s ease;
}

.sidenav ul .selected,
.sidenav-bottom-nav .selected {
  font-weight: 600;
  color: var(--color-primary-hover);
  background-color: var(--color-primary-soft);
}

.sidenav ul .nav-items:hover,
.sidenav-bottom-nav .nav-items:hover {
  background-color: var(--color-primary-soft);
  color: var(--color-primary-hover);
}

.sidenav ul .selected:hover,
.sidenav-bottom-nav .selected:hover {
  background-color: var(--color-primary-soft);
  color: var(--color-primary-hover);
}

.sidenav ul .selected .fa,
.sidenav-bottom-nav .selected .fa {
  color: var(--color-primary);
}

/* KTYT is the one row that carries an outside brand. Re-pointing the three
   tokens the pill above is built from repaints its hover, its selected ground
   and its glyph from a single place — no rule here restates the pill's
   geometry, so this row can never drift out of line with its neighbours.
   Palette is ktyt.org's own: --burgundy, --burgundy-d, and the site's
   hsl(340 30% 92%) secondary for the soft ground. */
.sidenav ul .nav-items.ktyt-nav {
  --color-primary: #710C33;
  --color-primary-hover: #4A0820;
  --color-primary-soft: #F1E4E9;
}

/* At rest the glyph sits on the same #18181B every neighbouring icon is drawn
   in, so the column still reads as one set; the brand only appears once the
   row is hovered or live. */
.sidenav ul .nav-items.ktyt-nav .sidenav-icon {
  color: #18181B;
  transition: color .15s ease;
}

.sidenav ul .nav-items.ktyt-nav:hover .sidenav-icon,
.sidenav ul .nav-items.ktyt-nav.selected .sidenav-icon {
  color: var(--color-primary-hover);
}

.sidenav ul .router-link {
  display: flex;
  align-items: center;
  /* Never centred. Centring would make the icon's x a function of the label's
     width, so it would drift across rows and slide during the collapse; packed
     to the start it is pinned to the pill's padding edge and cannot move. */
  justify-content: flex-start;
}

/* Labels fold away rather than being display:none'd (which cannot animate),
   leaving the icon behind as the sidenav retracts. The icon->label gap lives
   here, after the icon, so closing it also cannot shift the icon.
   Anything meant to sit beside the text (the Beta badge) has to live inside
   this span, or the row's slack would push it to the far edge. */
.sidenav ul .router-link > .d-none {
  flex: 1 1 auto;
  min-width: 0;
  max-width: 400px; /* large enough to never cap the label when expanded */
  margin-left: var(--sk-icon-gap);
  overflow: hidden;
  white-space: nowrap;
  opacity: 1;
  transition: opacity 0.18s ease, max-width 0.3s ease, margin-left 0.3s ease;
}

/* The ONLY thing the collapsed state changes about a nav row: the label folds
   away. The row's box — gutter, padding, icon slot — is deliberately left
   alone, so the icon is still sitting exactly where it was and the rail simply
   closes around it. Collapsed to nothing rather than display:none, so it can
   animate, and it stays in the accessibility tree, which is what names these
   icon-only links. */
.sidenav.collapsed ul .router-link > .d-none {
  max-width: 0;
  margin-left: 0;
  opacity: 0;
}

.sidenav-bottom-nav .signout-nav-item,
.sidenav-bottom-nav .signout-nav-item:hover {
  color: #FF383C;
}

.signout-nav-text {
  color: #FF383C;
}

.signout-nav-link {
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.signout-nav-link:focus {
  outline: none;
}

.signout-nav-link:focus-visible {
  outline: 2px solid rgba(255, 56, 60, 0.35);
  outline-offset: 3px;
  border-radius: var(--radius-md);
}

/* Every icon gets the same rigid slot, in both states and on every row. That
   single fact is what makes the icons a straight, immovable column: a slot
   that resized (or differed per icon) would move the glyph's centre. */
.sidenav-icon {
  display: block;
  width: var(--sk-icon-slot);
  height: var(--sk-icon-slot);
  flex: 0 0 var(--sk-icon-slot);
  object-fit: contain;
}

/* The Minyanim artwork is drawn in a tighter 18-unit viewBox than the other
   icons' 20-unit one, so it renders visibly small in an identical slot. Scale
   the glyph, not the box: a transform is painted, not laid out, so the slot —
   and therefore the column — is untouched. */
.sidenav-icon--minyunim {
  transform: scale(1.07);
}

.sidenav-footer {
  width: 100%;
  margin-top: auto;
}

.sidenav-bottom-nav {
  width: 100%;
  list-style: none;
  margin-bottom: 10px;
}

.sidenav-bottom-nav a:hover {
  text-decoration: unset;
}

.new-feature-badge {
  /* Nested in the label rather than being a flex item of the row, so it needs
     its own display instead of bootstrap's .d-lg-inline-flex. */
  display: inline-flex;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
  margin-left: 7px;
  padding: 2px 7px;
  min-width: 34px;
  height: 18px;
  border: 1px solid var(--color-primary);
  border-radius: 5px;
  background-color: transparent;
  color: var(--color-primary);
  font-size: 0.52rem;
  font-weight: 600;
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.sidenav ul .selected .new-feature-badge,
.sidenav-bottom-nav .selected .new-feature-badge {
  border-color: var(--color-primary-hover);
  color: var(--color-primary-hover);
}

.sidenav .profile-card {
  border: 1px solid var(--color-border);
  padding: 0px;
  border-radius: var(--radius-lg);
  width: 90%;
  margin-left: 5%;
  box-shadow: var(--shadow-sm);
  margin-top: auto;
}

.sidenav .profile-card .card-body {
  padding: 0px;
}

.sidenav .profile-card .card-header {
  background-image: url('../assets/images/sidenav-profile-card.png'); /* Update with your image path */
  background-size: cover;
  background-position: center;
  min-height: 80px;
  border-radius: 8px 8px 0 0;
}

.sidenav .profile-card .logo {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FFFFFF;
  border: 2px solid var(--color-primary-border);
  border-radius: 7px!important;
  position: relative;
  bottom: 25px;
  width: 25%;
  margin-left: 37.5%;
}

.sidenav .profile-card .card-body .content {
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: 12px;
}

.sidenav .profile-card .name {
  color: #21232B;
  font-size: 0.9rem;
  font-size: 500;
  position: relative;
  bottom: 20px;
  margin-bottom: 0px;
}

.sidenav .profile-card .email {
  color: #737373;
  font-size: 0.65rem;
  font-size: 300;
  position: relative;
  bottom: 15px;
  margin-bottom: 0px;
}

.sidenav .profile-card .content small.text-center {
  display: block;
  text-align: center;
  margin: 0 auto;
  margin-top: 5px;
  font-size: 0.7rem;
  color: #737373;
}


/* ------------------------------ unread badge ----------------------------- */
/* Inside the label, like the New Update badge, so the row's slack cannot
   push it to the far edge; it folds away with the label when the rail
   retracts. */
.sidenav-badge {
  margin-left: 7px;
  vertical-align: middle;
}

/* The retracted rail has no label: a dot on the icon says there is
   something waiting. Positioned off the row, so the icon column itself is
   untouched. */
.sidenav ul .router-link {
  position: relative;
}

.sidenav-icon-dot {
  display: none;
  position: absolute;
  top: -3px;
  left: calc(var(--sk-icon-slot) - 5px);
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #FF383C;
  box-shadow: 0 0 0 2px var(--color-bg-canvas);
}

.sidenav.collapsed .sidenav-icon-dot {
  display: block;
}

/* NOTE: there are deliberately no breakpoint overrides for the rail's padding,
   the pill's padding or the icon size. They used to vary (15px / 18px / 15px
   of rail padding, 18px / 22px icons), which moved the icon column sideways as
   the window was resized and gave the two states different anchors to animate
   between. The geometry is now one set of fixed lengths at every width. */
</style>
